const StartBlock = ({ children }) => {
  return <div sx={{ mb: "4rem", textAlign: "right", pr: "0" }}>{children}</div>
}

export default StartBlock
